// 01 LANDING
export const c_hero = `La Fabrique des Marques Modernes.`
export const c_tag = `Ancrée au Sénégal, au Service du Monde Entier.`

// export const c_hero = `360° Creative company based in Dakar`
// export const c_whatwedo = `We empower Brands through innovative design and strategic creativity.`
export const c_whatwedo = `Nous donnons du pouvoir aux marques grâce à un design innovant et une créativité stratégique.`
export const c_descr = `Nous avons fourni des services de conception d'identité de marque, de production médiatique, de design en 3D et motion design, ainsi que de conception et développement UI/UX à plus de 100 entreprises dans le monde et particulièrement chez nous au Sénégal.`